import { render, staticRenderFns } from "./BillingItem.vue?vue&type=template&id=f6d753f4&"
import script from "./BillingItem.vue?vue&type=script&lang=js&"
export * from "./BillingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6d753f4')) {
      api.createRecord('f6d753f4', component.options)
    } else {
      api.reload('f6d753f4', component.options)
    }
    module.hot.accept("./BillingItem.vue?vue&type=template&id=f6d753f4&", function () {
      api.rerender('f6d753f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/billing/components/BillingItem.vue"
export default component.exports